import { useCallback } from 'react';
import { renderToString } from 'react-dom/server';
import langUtils, { STRING_CONST } from 'containers/language/utils';
import { useStyles } from '../styles';
import { getConversation_conversations_data_messages } from '../../../__generated__/getConversation';
import { IMAGE_POPUP_TEXT_ACTION, TRACK_EVENT } from '../../../utils/analytics';
import useExpandedMessageTaffiIds from './useExpandedMessageTaffiIds';
import useAnalytics from './useAnalytics';
import useSelectedElement from './useSelectedElement';
import useConversation from './useConversation';

const useReadMoreButton = () => {
    const classes = useStyles();
    const { addExpandedMessageTaffiId, expandedMessageTaffiIds } = useExpandedMessageTaffiIds();
    const { selectedElement } = useSelectedElement();
    const { conversation } = useConversation();
    const handleAnalytics = useAnalytics();

    const readMoreButton = useCallback(
        (message: getConversation_conversations_data_messages) =>
            renderToString(
                <span>
                    <span>...</span>{' '}
                    <span className={classes.readMoreText}>{`${langUtils.getLanguageStr(
                        STRING_CONST.READ_MORE,
                        message?.language,
                    )}`}</span>
                </span>,
            ),
        [classes.readMoreText],
    );

    const handleShowMore = useCallback(
        (message: getConversation_conversations_data_messages) => {
            if (!message?.taffiId) {
                return;
            }
            if (!expandedMessageTaffiIds?.includes(message.taffiId)) {
                addExpandedMessageTaffiId(message.taffiId);
                handleAnalytics(
                    TRACK_EVENT.STYLE_CHAT_DESCRIPTION_ACTION,
                    {
                        ...message,
                        conversationId: message?.conversationId || conversation?.id,
                        actionType: IMAGE_POPUP_TEXT_ACTION.MORE,
                    },
                    selectedElement,
                );
            }
        },
        [addExpandedMessageTaffiId, conversation?.id, expandedMessageTaffiIds, handleAnalytics, selectedElement],
    );

    return { readMoreButton, handleShowMore };
};

export default useReadMoreButton;
